__turbopack_context__.v({
  "button-card": "Q3AmaW_button-card",
  "reset-button": "Q3AmaW_reset-button",
});
